import React from 'react';
import { Provider } from 'react-redux';
import Checkout, { sliceReducers } from '../../../components/Checkout';
import AMS from '../../../shared/lib/ams-security-api';
import injectI18n from '../../../shared/utils/injectI18n';
import injectGooglePayUtils from '../../../components/common/Payment/components/PaymentMethods/utils/injectGooglePayUtils';
import configureWidgetStore from '../../../store/utils/configureWidgetStore';
import { middleware, apiReducers } from '../../../store/services/checkout';
import Loadder from '../../../components/common/Loading/Loadder';
import { pickFuncFromObject } from '../../../shared/utils/commonUtils';

window.AMS = window.AMS || AMS;

const CheckoutCom = injectI18n(injectGooglePayUtils((props) => {
  return <Checkout {...props}/>;
}));

const CheckoutWidget = (props) => {
  const { checkoutConfig, locale, ...rest } = props;
  const params = { ...checkoutConfig, ...rest, locale };
  const { show, hide, ...restFunc } = pickFuncFromObject(params);
  const store = configureWidgetStore({
    preloadedState: {
      propsData: params,
    },
    reducer: {
      ...apiReducers,
      ...sliceReducers,
    },
    middleware,
  });
  return <Provider store={store}>
    <Loadder show={show} hide={hide} />
    <CheckoutCom {...restFunc} locale={locale} />
  </Provider>;
};

CheckoutWidget.widgetNameSpace = 'checkout-widget';

export default CheckoutWidget;
